import { GTCPageDetail } from './GTCPageDetail';

export default GTCPageDetail;
